export enum EnumTamanhoPapel {
  Layout58mm = 'Layout58mm',
  Layout58mm32car = 'Layout58mm32car',
  Layout80mm = 'Layout80mm',
  Layout80mm42car = 'Layout80mm42car',
  LayoutA4 = 'LayoutA4'

}
